import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      home: {
        title: 'Welcome to Joy Hostel',
        desc: 'A digital nomad-friendly hostel in the heart of Sarajevo, perfect for work and life.',
        bookNow: 'Under construction',
        about: 'About Us',
        aboutDesc: 'Joy Hostel is located in the center of Sarajevo, designed for digital nomads and backpackers. We offer a cozy coworking area, a fully equipped kitchen, spacious and clean bathrooms, and high-speed WiFi throughout. Female-only dorms ensure a safe and comfortable stay for everyone.',
        aboutNomad: 'Special long-stay discounts for digital nomads!',
        features: ['Coworking Area', 'Shared Kitchen', 'Spacious Bathrooms', 'Female Dorms', 'High-speed WiFi', 'Nomad Discount'],
        popularRooms: 'Popular Rooms',
        room_8: '8-Bed Mixed Dorm',
        room_4: '4-Bed Mixed Dorm',
        room_female3: '3-Bed Female Dorm',
        price_8: '€10/person/night',
        price_4: '€12/person/night',
        price_female3: '€14/person/night',
        book: 'Book',
        notice: 'Guest Information',
        notice_items: [
          'Check-in: from 14:00, latest 20:00',
          'Check-out: before 11:00',
          'Valid ID (passport/ID card) required at check-in',
          'Deposit: Some rooms require a deposit, refundable at check-out if no damage',
          'No smoking in the hostel, please keep quiet in public areas',
          'Please inform the front desk in advance for late check-out',
          'Contact us for any questions',
          'JOY Check-in Notice',
          'The entrance door on the fourth floor is unlocked, please open and close it yourself. Be sure to close the door after entering or exiting. Knock before entering any room (including the bathroom). Please turn off the lights and close the door when leaving.',
          'Toilet paper can be thrown directly into the toilet, but do not throw any other items into the toilet. Collect and dispose of shavings or nails in the trash can. Use the trash can according to the label. Keep the bathroom and toilet clean after use.',
          'Get permission before using the kitchen. The kitchen only provides basic utensils and tableware, other items such as oil, salt, and seasonings need to be purchased by yourself. Clean and tidy up immediately after using the kitchen, including the stove, countertops, and residues in the sink, to avoid affecting others.',
          'Check-out time is 11:00 AM. Please pack your personal belongings and vacate the bed before check-out time to keep it tidy. If the bed is not vacated after 11:30, it will be considered as overtime check-out. Overtime check-out will incur additional charges:',
          'Overtime 1 hour, half-day room charge will be added.',
          'Overtime 6 hours, one-day room charge will be added.',
          'Do not make loud noises or disturb others at any time, such as playing mobile phones at high volume.',
          'For the safety of the living environment, we do not accept visitors. Your friends need permission to come here. Please keep your valuables safe, we are not responsible for any loss.',
          'The dining table is for dining or temporary work purposes only, do not occupy it for a long time, and clean it immediately after use. Please move social activities to the bar or cafe downstairs, which provides a rich place for communication.',
          'Please maintain personal hygiene, your bed must use sheets, quilt covers, and pillowcases (install and remove them yourself). Do not sit, lie, or place items on beds that are not yours. Pay for laundry yourself, and do not wash/dry clothes, shoes, and socks anywhere other than the laundry room. It is strictly forbidden to place food and drinks on the bed. If the room and bed are damaged, you will need to pay for it.',
          'Please abide by the above items, face-to-face is not elegant',
          'The wooden door of the building may be closed at 10 pm, so it is best not to return late..',
          'Wi-Fi: Joy / Joy 5G / Joy EXT ',
          'Wi-Fi Password: 3.1415926',
          'Building Door Password: 9527#',
          'WhatsApp: +387 66 979 000',
          'WeChat: Gauthier724',
        ],
        navbar: {
          payment: 'Payment',
          booking: 'Booking',
          notice: 'Guest Information',
          adminDashboard: 'Admin Dashboard',
          adminLogin: 'Admin Login'
        },
        footer: {
          copyright: 'Powered by Freedom & Wi-Fi @ Sarajevo © Joy Hostel'
        }
      },
      booking: {
        online: 'Book Online',
        selectRoom: 'Select Room Type',
        name: 'Name',
        email: 'Email',
        checkin: 'Check-in',
        checkout: 'Check-out',
        next: 'Next',
        back: 'Back',
        pay: 'Pay',
        customAmount: 'Custom Amount (€)',
        note: 'Note (optional)',
        confirm: 'Please confirm your booking:',
        room: 'Room:',
        custom: 'Custom Payment / Long Stay Discount',
      },
      admin: {
        order: 'Order Management',
        status: 'Room Status',
        roomManage: 'Room Management',
        export: 'Export Orders',
        ical: 'iCal Sync',
        manage: 'Manage Rooms',
        guest: 'Guest',
        room: 'Room',
        checkin: 'Check-in',
        checkout: 'Check-out',
        total: 'Total',
        booked: 'Booked',
        available: 'Available',
        ical_coming_soon: 'iCal sync feature coming soon...',
        room_manage_coming_soon: 'Room management feature coming soon...'
      },
      error: {
        fetch_orders: 'Failed to fetch orders',
        fetch_status: 'Failed to fetch room status',
        export: 'Failed to export orders'
      },
      loading: 'Loading...',
      pagination: {
        prev: 'Previous',
        next: 'Next',
        page: 'Page {{page}} of {{total}}'
      },
      footer: {
        copyright: 'Powered by Freedom & Wi-Fi @ Sarajevo © Joy Hostel'
      }
    },
  },
  zh: {
    translation: {
      home: {
        title: '欢迎来到 Joy Hostel',
        desc: '萨拉热窝市中心，数字游民友好型青旅，舒适办公与生活空间',
        bookNow: '施工中',
        about: '关于我们',
        aboutDesc: 'Joy Hostel位于萨拉热窝市中心，专为数字游民和背包客设计。我们提供舒适的办公区、设施齐全的厨房、宽敞洁净的浴室和洗手间。高速稳定WiFi覆盖全屋，女生专属房型让每位旅客都能安心入住。',
        aboutNomad: '数字游民可享常住优惠，欢迎长期入住！',
        features: ['公共办公区', '公共厨房', '宽敞浴室', '女生专属房', '高速WiFi', '数字游民优惠'],
        popularRooms: '热门房型推荐',
        room_8: '混住八人间',
        room_4: '混住四人间',
        room_female3: '女生三人间',
        price_8: '每人每天10欧元',
        price_4: '每人每天12欧元',
        price_female3: '每人每天14欧元',
        book: '预订',
        notice: '入住须知',
        notice_items: [
          '入住时间：14:00 起，最晚 20:00',
          '退房时间：11:00 前',
          '入住需出示有效身份证件（护照/身份证）',
          '押金：部分房型需收取押金，退房时如无损坏全额退还',
          '全馆禁烟，公共区域请保持安静',
          '如需延迟退房请提前告知前台',
          '如有疑问请联系工作人员',
          '四楼入户门不锁，请自行开关出入，出入后请务必随手关门。进入任何房间（包括洗手间）前，请先敲门。请随手关灯、关门。',
          '厕纸可以直接丢进马桶，除此以外请勿向马桶丢任何其它物品。剃须或指甲请自行收集丢弃在垃圾桶内。请按标识分类使用垃圾桶。使用洗手间和马桶后请保持清洁。',
          '使用厨房前需事先征得同意。厨房仅提供基本厨具和餐具，其它如油，盐、调料等需自行购买。使用厨房后请立即清洁和整理，包括炉灶、台面以及水槽中的残渣，以免影响他人使用。',
          '退房时间为 中午 11:30。请在退房时间前收拾好个人物品并腾空床铺，以便我们整洁。11：30 之后床铺仍未腾空即视为超时退房。超时退房将加收费用：',
          '超时 1 小时，加收半天房费。',
          '超时 6 小时，加收一天房费。',
          '任何时候请勿高声喧哗或制造噪音干扰他人，如手机外放大音量等。',
          '为了居住环境安全，我们不接待访客，您的朋友需要经过同意才能来到这里。请妥善保管好个人贵重物品，如有丢失，概不负责。',
          '餐桌仅供用餐或临时工作用途，请勿长期占用，使用后请立即清理。社交活动请移步楼下酒吧或咖啡馆，该区域提供丰富的交流场所。',
          '请保持个人卫生，您的床铺必须使用床单、被罩和枕套（自行装卸）。不是您的床铺，请勿坐卧和放置物品。洗衣请自觉付费，禁止在洗衣房以外的任何地方洗衣/晾晒衣物鞋袜。严禁将食品和饮料放置在床上，房间和床铺如有污损，您需要照价赔偿。',
          '以上各项，敬请遵守，面斥不雅',
          '大楼木制大门可能会在晚间10点关闭，最好不要晚归',
          'Wi-Fi:Joy / Joy 5G / Joy EXT',
          'Wi-Fi Password：3.1415926',
          'Building Door Password: 9527#',
          'WhatsApp：+387 66 979 000',
          '微信：Gauthier724',
        ],
        navbar: {
          payment: '支付',
          booking: '施工中',
          notice: '入住须知',
          adminDashboard: '管理后台',
          adminLogin: '管理员登录'
        },
        footer: {
          copyright: '本站由 Freedom & Wi-Fi 提供技术支持 © 萨拉热窝 Joy Hostel'
        }
      },
      booking: {
        online: '在线支付',
        selectRoom: '选择房型',
        name: '姓名',
        email: '邮箱',
        checkin: '入住日期',
        checkout: '退房日期',
        next: '下一步',
        back: '上一步',
        pay: '去支付',
        customAmount: '自定义金额（欧元）',
        note: '备注（可选）',
        confirm: '请确认订单信息：',
        room: '房型：',
        custom: '自定义付款/长住优惠',
      },
      admin: {
        order: '订单管理',
        status: '房态管理',
        roomManage: '房型管理',
        export: '导出订单',
        ical: 'iCal同步',
        manage: '管理房型',
        guest: '客人',
        room: '房型',
        checkin: '入住',
        checkout: '退房',
        total: '总数',
        booked: '已预订',
        available: '可用',
        ical_coming_soon: 'iCal同步功能开发中...',
        room_manage_coming_soon: '房型管理功能开发中...'
      },
      error: {
        fetch_orders: '获取订单失败',
        fetch_status: '获取房态失败',
        export: '导出订单失败'
      },
      loading: '加载中...',
      pagination: {
        prev: '上一页',
        next: '下一页',
        page: '第 {{page}} 页，共 {{total}} 页'
      },
      footer: {
        copyright: '本站由 Freedom & Wi-Fi 提供技术支持 © 萨拉热窝 Joy Hostel'
      }
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator', 'htmlTag', 'cookie', 'localStorage', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n; 
